module.exports = __webpack_public_path__ + "img/belleplagne.3f7f94ec.jpg";